module.exports = __webpack_public_path__ + "static/media/green_check.a0fd83da.svg";